import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import FilterList from './FilterList';
import style from './index.scss';

import filterAppliedImg from '../../assets/filterApplied.png';
import { isEmpty } from '../../util/lodashlike';

class ColumnFilter extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);

    const { filterGroupData, userFilterSetting } = this.props;
    const checkboxStates = {};
    if (filterGroupData) {
      filterGroupData.forEach((filter, i) => {
        checkboxStates[filter.name] = checkboxStates[filter.name] || {};
        filter.group.forEach((item) => {
          if (userFilterSetting[filter.name]) {
            //set 2d array to avoid the duplicated name in different group
            checkboxStates[filter.name][item.name] =
              userFilterSetting[filter.name][item.name];
          } else {
            checkboxStates[filter.name][item.name] = true;
          }
        });
      });
    }

    this.state = {
      isHidden: true,
      checkboxStates
    };

    this.tempCheckBoxStates = [];
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { filterGroupData, userFilterSetting } = nextProps;
    const checkboxStates = {};

    if (filterGroupData) {
      filterGroupData.forEach((filter, i) => {
        checkboxStates[filter.name] = checkboxStates[filter.name] || {};
        filter.group.forEach((item) => {
          if (userFilterSetting[filter.name]) {
            //set 2d array to avoid the duplicated name in different group
            checkboxStates[filter.name][item.name] =
              userFilterSetting[filter.name][item.name];
          } else {
            checkboxStates[filter.name][item.name] = true;
          }
        });
      });
    }

    this.setState({
      ...this.state,
      isHidden: true,
      checkboxStates
    });
  }

  onCancel = () => {
    let checkboxStates = this.state.checkboxStates;

    this.tempCheckBoxStates.forEach((boxState) => {
      checkboxStates[boxState[0]][boxState[1]] =
        !checkboxStates[boxState[0]][boxState[1]];
    });

    this.setState({
      ...this.state,
      isHidden: true,
      checkboxStates
    });

    this.tempCheckBoxStates = [];
  };

  onCheckboxChange = (groupTitle, filterName) => {
    const { checkboxStates } = this.state;

    let isInTemp = this.tempCheckBoxStates.filter((boxState) => {
      return boxState[0] == groupTitle && boxState[1] == filterName;
    });
    if (isInTemp.length == 0) {
      this.tempCheckBoxStates.push([groupTitle, filterName]);
    }

    checkboxStates[groupTitle][filterName] =
      !checkboxStates[groupTitle][filterName];

    this.setState({
      ...this.state,
      checkboxStates
    });
  };

  onConfirm = () => {
    const { handleConfirm } = this.props;

    if (handleConfirm) {
      handleConfirm(this.state.checkboxStates);
      this.setState({
        ...this.state,
        isHidden: true
      });
    }

    this.tempCheckBoxStates = [];
  };

  onToggle = () => {
    this.setState({
      ...this.state,
      isHidden: !this.state.isHidden
    });
  };

  render() {
    const { isHidden, checkboxStates } = this.state;
    const { filterGroupData, statusNo } = this.props;

    let filterList = [];
    if (filterGroupData) {
      for (let i = 0; i < filterGroupData.length; i++) {
        let filter = filterGroupData[i];

        //only Closed status table has Result and STR columns
        if (statusNo != 2 && (filter.name == 'result' || filter.name == 'str'))
          continue;

        filterList.push(
          <FilterList
            key={i}
            filter={filter}
            checkboxStates={checkboxStates[filter.name]}
            onCheckboxChange={this.onCheckboxChange}
          />
        );
      }
    }

    return (
      <div className={style.wrapper}>
        <a className={style.filterTrigger} onClick={this.onToggle}>
          <span>Filter</span>
          <img
            className={style.triggerIcon}
            src={filterAppliedImg}
            alt="checked"
          />
        </a>
        <div
          className={classnames(style.filterContent, 'filter-content')}
          style={{ display: isHidden ? 'none' : 'block' }}>
          <div className={style.bodyTitle}>Column Filter</div>
          <div className={style.filterBody}>{filterList}</div>
          <div className={style.contentFooter}>
            <button
              className="btn btn-tertiary"
              type="button"
              onClick={this.onCancel}>
              Cancel
            </button>
            <button
              className="btn btn-secondary"
              type="button"
              onClick={this.onConfirm}>
              Apply
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ColumnFilter.propTypes = {
  filterGroupData: PropTypes.array.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  statusNo: PropTypes.number,
  userFilterSetting: PropTypes.object
};

export default ColumnFilter;
